import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { getFundUpdatesStats } from 'src/app/home/adapters'
import {
  mapFundUpdateStats,
  type IMapFundUpdateStatsReturn,
} from 'src/app/home/pages/fund-updates/domain/use-cases/map-fund-update-stats'
import { fundUpdatesKeys } from 'src/app/home/queries/keys'

export interface IUseFundUpdatesStatsQueryParams {
  enabled: boolean
  silentErrorToast?: boolean
}

export const useFundUpdatesStatsQuery = (
  params: IUseFundUpdatesStatsQueryParams,
): UseQueryResult<IMapFundUpdateStatsReturn, Error> => {
  const { t } = useTranslation()

  return useQuery({
    queryKey: fundUpdatesKeys.stats(),
    ...(params.silentErrorToast ? { meta: { silent: true } } : {}),
    queryFn: async (): Promise<IMapFundUpdateStatsReturn> => {
      const response = await getFundUpdatesStats()
      return mapFundUpdateStats(response, t)
    },
    enabled: params.enabled,
  })
}
